export const MaxCharLimits = {
  INPUT: 'Max 250 character',
  URL: 'Max 500 character',
  NOTES: 'Max 10000 character',
  TEXT_EDITOR: 'Max 100000 character',
} as const;
